/* ============================================================
   WORKSPACE v4 — PROTOTAIP DESIGN  (/workspace-v4)
   ============================================================
   ⛔ PROTOTAIP UI/UX SAHAJA (arahan user 15 Okt 2026: "ini kan prototaip
      je. buang apa yg wired. aku nk buat design ui ux je").
      • Tiada callable / Firestore / storan / modal library sebenar.
      • Semua isi = data contoh (utils/generateV2.js). Generate tidak
        membuat apa-apa — corak sama seperti prototaip /workspace-v3.9.
      • Pilihan tidak diingat selepas reload (sengaja — prototaip).
      Sambung ke server HANYA bila user minta dengan jelas.

   Langkah (keputusan user 15 Okt 2026): Add product → Select module (tag) →
     Video style → Scene → Model → Avatar → Generate.
   Rupa (18 Okt 2026, susunan B dipilih daripada 3 lakaran): galeri style di
     kiri + panel tetapan melekat di kanan — lihat GenerateV2Komposer.jsx.

   Laluan didaftar bersama halaman prototaip v3.9 dalam App.jsx (admin
   sahaja); menu "Workspace" shell lakaran (design/StudioShell.jsx) membuka
   halaman ini. Generate lama / WorkspaceView / extension TIDAK disentuh.

   UI = English. Bila dibuka kepada pelanggan, semua ayat wajib masuk
   kamus i18n dahulu + pil EN/BM dipasang.
   ============================================================ */

import { useRef, useState } from 'react';

import { LayoutGrid, Bot, Split, Music2, ChevronsUpDown, ChevronsDownUp, PanelRightOpen, PanelRightClose } from 'lucide-react';

import { Btn, PageHeader, Segmented, EmptyState } from '../design/ui';
import GroupSwitcherV39 from './GroupSwitcherV39';
import SusunMenuV39 from './SusunMenuV39';
import { ProductRow } from './WorkspaceV39View';
import GenerateV2Komposer from './GenerateV2Komposer';
import PhoneAutomationPanel from './PhoneAutomationPanel';
import ScheduleTabPrototype from './ScheduleTabPrototype';
import {
    TAG_CONTOH, STYLE_CONTOH, PRODUK_CONTOH, MODEL_CONTOH, AVATAR_CONTOH, GROUP_CONTOH, TAB_CONTOH, KAD_CONTOH, SUSUN_CONTOH, susunKad,
    idPopular, sebabTakBolehJana, KAD_KOSONG,
    MATLAMAT_CONTOH, FORMAT_CONTOH, SUSUN_STYLE, tapisMatlamat, susunStyle,
} from '../utils/generateV2';

/* "Popular" dikira daripada SEMUA style (bukan selepas tapisan tag) — kalau dikira dalam
   tapisan, hampir setiap kad dalam satu module akan berlabel Popular dan label itu hilang makna. */
const POPULAR = idPopular(STYLE_CONTOH);
const IKON_TAB = { generate: LayoutGrid, agent: Bot, flow: Split, schedule: Music2 };

export default function WorkspaceV4PilotView() {
    const kiraRef = useRef(2);
    const [produk, setProduk] = useState(() => PRODUK_CONTOH.slice(0, 2).map((item, i) => ({ kunci: `${item.id}#${i + 1}`, item })));
    const [matlamatId, setMatlamatId] = useState('');   // '' = All (lalai)
    const [formatId, setFormatId] = useState('');       // '' = semua format
    const [susunStyleId, setSusunStyleId] = useState('guna');
    const [styleId, setStyleId] = useState('');
    const [bilBabak, setBilBabak] = useState(3);
    const [modelId, setModelId] = useState(MODEL_CONTOH[0].id);
    const [avatarId, setAvatarId] = useState('');
    /* Kepala Workspace (arahan user 18 Okt, "jgn ada wired"): group + tab = keadaan tempatan sahaja.
       GroupSwitcherV39 = komponen v3.9 SEBENAR (UI tulen, tiada Firebase) — dipakai, bukan disalin. */
    const [groups, setGroups] = useState(GROUP_CONTOH);
    const [groupAktif, setGroupAktif] = useState(GROUP_CONTOH[0].id);
    const [tab, setTab] = useState('generate');
    /* Tab My Agent + Flow: 3 kad contoh (ProductRow v3.9 SEBENAR) + susun + buka/tutup semua.
       Klik baris / tick = tiada kesan luar (prototaip, "jgn ada wired"). */
    const [susunJenis, setSusunJenis] = useState('masa');
    const [susunArah, setSusunArah] = useState('desc');
    const [bukaSemua, setBukaSemua] = useState(false);
    const [kadDipilih, setKadDipilih] = useState(() => new Set());
    /* Control Panel KOSONG (arahan user 18 Okt) — muncul di kanan senarai kad tab My Agent / Flow
       bila "Show Control Panel" ditekan; butang Show/Hide di baris kepala, sebaris dengan susun (arahan user 18 Okt). */
    const [cpBuka, setCpBuka] = useState(false);
    const tabKad = tab === 'agent' || tab === 'flow';
    const togolKad = (id) => setKadDipilih((s) => { const b = new Set(s); if (b.has(id)) b.delete(id); else b.add(id); return b; });
    const tabOptions = TAB_CONTOH.map((o) => {
        const Ikon = IKON_TAB[o.value];
        return {
            value: o.value,
            label: (
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 7 }}>
                    <Ikon size={15} strokeWidth={1.8} />{o.label}
                    {o.kira != null && <span style={{ fontSize: 11.5, color: 'var(--s-ink-3)', fontVariantNumeric: 'tabular-nums' }}>{o.kira}</span>}
                </span>
            ),
        };
    });

    /* Blank Card = kad TETAP pertama, hanya dalam tab All Formula TANPA tapisan format
       (arahan user 22 Okt + 1 Nov: ia bukan Video/Image/Text, jadi sorok bila tapisan format aktif). */
    const styles = [...((matlamatId || formatId) ? [] : [KAD_KOSONG]), ...susunStyle(tapisMatlamat(STYLE_CONTOH, matlamatId, formatId), susunStyleId)];
    const kiraMatlamat = Object.fromEntries(['', ...MATLAMAT_CONTOH.map((m) => m.id)].map((id) => [id, tapisMatlamat(STYLE_CONTOH, id, '').length]));
    /* Style yang dipilih tetapi tiada dalam tapisan tag semasa = tidak dipilih. */
    const styleBerkesan = styles.some((s) => s.id === styleId) ? styleId : '';
    const styleKosong = styles.find((s) => s.id === styleBerkesan)?.kosong === true;
    const avatarSorok = styles.find((s) => s.id === styleBerkesan)?.tanpaMuka === true;

    /* Add Product (prototaip): lampir produk contoh seterusnya, berpusing. */
    const tambahProduk = () => {
        const item = PRODUK_CONTOH[kiraRef.current % PRODUK_CONTOH.length];
        kiraRef.current += 1;
        setProduk((s) => [...s, { kunci: `${item.id}#${kiraRef.current}`, item }]);
    };

    return (
        <div className="sesaat-m-tight" style={{ padding: '26px 28px 48px' }}>
            <PageHeader
                title="Workspace"
                sisiTajuk={(
                    <>
                        <span className="s-chiprule" />
                        <GroupSwitcherV39
                            groups={groups}
                            aktif={groupAktif}
                            onPilih={setGroupAktif}
                            onCipta={(nama) => setGroups((g) => [...g, { id: 'g-' + Date.now().toString(36), nama, kira: 0 }])}
                        />
                        {/* 4 tab duduk SEBELAH KANAN pemilih group (arahan user 18 Okt). */}
                        <Segmented value={tab} onChange={setTab} options={tabOptions} />
                    </>
                )}
                suisBahasa
                actions={(
                    <>
                        {/* Nota prototaip + butang Current Workspace DIBUANG (arahan user 18 Okt). */}
                        {/* Susun + buka/tutup semua: HUJUNG KANAN baris yang sama dengan 4 tab
                            (arahan user 18 Okt). Hanya pada tab yang ada senarai kad. */}
                        {tabKad && (
                            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                                <SusunMenuV39
                                    pilihan={SUSUN_CONTOH}
                                    jenis={susunJenis}
                                    arah={susunArah}
                                    onTukar={(j, a) => { setSusunJenis(j); setSusunArah(a); }}
                                />
                                <Btn
                                    variant="ghost"
                                    size="sm"
                                    onClick={() => setBukaSemua((v) => !v)}
                                    title={bukaSemua ? 'Collapse all' : 'Expand all'}
                                    aria-label={bukaSemua ? 'Collapse all' : 'Expand all'}
                                    icon={bukaSemua ? <ChevronsDownUp size={14} strokeWidth={2} /> : <ChevronsUpDown size={14} strokeWidth={2} />}
                                />
                            </span>
                        )}
                        {/* Butang Show Control Panel (arahan user 18 Okt) — rupa SAMA seperti
                            /workspace-v3.9. PROTOTAIP: tiada Control Panel di sini, jadi ia tidak
                            membuat apa-apa. Suis EN/BM = SuisBahasa v3.9 sebenar (elemen terakhir). */}
                        {/* Show / Hide Control Panel — KEKAL sebaris dengan butang susun (arahan user 18 Okt). */}
                        {tabKad && (
                            <Btn
                                variant="ghost"
                                size="sm"
                                icon={cpBuka ? <PanelRightClose size={14} strokeWidth={2} /> : <PanelRightOpen size={14} strokeWidth={2} />}
                                onClick={() => setCpBuka((v) => !v)}
                            >
                                {cpBuka ? 'Hide Control Panel' : 'Show Control Panel'}
                            </Btn>
                        )}
                    </>
                )}
            />

            {tabKad ? (
              <div className="gv2-kadcp" data-cp={cpBuka ? 'buka' : 'tutup'}>
                <div style={{ background: 'var(--s-card)', border: '1px solid var(--s-line)', borderRadius: 'var(--s-r-lg)', overflow: 'hidden', minWidth: 0 }}>
                    {susunKad(KAD_CONTOH[tab], susunJenis, susunArah).map((p, i, semua) => (
                        <ProductRow
                            key={p.id}
                            p={p}
                            selected={kadDipilih.has(p.id)}
                            onToggle={() => togolKad(p.id)}
                            last={i === semua.length - 1}
                            onOpen={() => {}}
                        />
                    ))}
                </div>
                {cpBuka && (
                    <aside className="s-panelbox gv2-cp" aria-label="Control Panel">
                        <div className="gv2-cp__kepala">
                            <p className="s-cardhead__t" style={{ margin: 0 }}>Control Panel</p>
                        </div>
                        {/* PROTOTAIP Phone automation (post ke telefon / Shopee) — rupa sahaja, tiada wire. */}
                        <PhoneAutomationPanel />
                    </aside>
                )}
              </div>
            ) : tab === 'schedule' ? (
                <ScheduleTabPrototype />
            ) : tab !== 'generate' ? (
                <EmptyState title={`${TAB_CONTOH.find((o) => o.value === tab)?.label} is not part of this prototype`}>
                    Only the Generate tab is designed here.
                </EmptyState>
            ) : (
            <GenerateV2Komposer
                produk={produk}
                onTambah={tambahProduk}
                onBuang={(kunci) => setProduk((s) => s.filter((p) => p.kunci !== kunci))}
                tags={TAG_CONTOH}
                matlamat={MATLAMAT_CONTOH}
                matlamatId={matlamatId}
                onMatlamat={setMatlamatId}
                kiraMatlamat={kiraMatlamat}
                format={FORMAT_CONTOH}
                formatId={formatId}
                onFormat={setFormatId}
                susun={SUSUN_STYLE}
                susunId={susunStyleId}
                onSusun={setSusunStyleId}
                styles={styles}
                styleId={styleBerkesan}
                onStyle={setStyleId}
                popular={POPULAR}
                bilBabak={bilBabak}
                onBabak={setBilBabak}
                model={MODEL_CONTOH}
                modelId={modelId}
                onModel={setModelId}
                avatar={AVATAR_CONTOH}
                avatarId={avatarId}
                onAvatar={setAvatarId}
                avatarSorok={avatarSorok}
                sebabTakBoleh={sebabTakBolehJana({ produk, styleId: styleBerkesan, kosong: styleKosong })}
            />
            )}
        </div>
    );
}
